/* eslint-disable default-case */
/* eslint-disable radix */
/* eslint-disable no-cond-assign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable max-classes-per-file */

/**
 * @namespace aria
 */
const aria = {};
window.aria = aria;

/**
 * @desc
 *  Key code constants
 */
aria.KeyCode = {
  BACKSPACE: 8,
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  PAGE_UP: 33,
  PAGE_DOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
};

/**
 * @constructor
 *
 * @desc
 *  Listbox object representing the state and interactions for a listbox widget
 *
 * @param listboxNode
 *  The DOM node pointing to the listbox
 */
aria.Listbox = function (listboxNode) {
  this.listboxNode = listboxNode;
  this.activeDescendant = this.listboxNode.getAttribute('aria-activedescendant');
  this.multiselectable = this.listboxNode.hasAttribute('aria-multiselectable');
  this.moveUpDownEnabled = false;
  this.siblingList = null;
  this.upButton = null;
  this.downButton = null;
  this.moveButton = null;
  this.listboxButton = null;
  this.keysSoFar = '';
  this.handleFocusChange = function () {};
  this.handleItemChange = function (event, items) {};
  this.registerEvents();
};

/**
 * @desc
 *  Register events for the listbox interactions
 */
aria.Listbox.prototype.registerEvents = function () {
  this.listboxNode.addEventListener('focus', this.setupFocus.bind(this));
  this.listboxNode.addEventListener('keydown', this.checkKeyPress.bind(this));
  this.listboxNode.addEventListener('click', this.checkClickItem.bind(this));
};

aria.ListboxButton = function (button, listbox) {
  this.button = button;
  this.listbox = listbox;
  this.registerEvents();
};

aria.ListboxButton.prototype.registerEvents = function () {
  this.button.addEventListener('click', this.showListbox.bind(this));
  this.button.addEventListener('keyup', this.checkShow.bind(this));
  this.listbox.listboxNode.addEventListener('blur', this.hideListbox.bind(this));
  this.listbox.listboxNode.addEventListener('keydown', this.checkHide.bind(this));
  this.listbox.setHandleFocusChange(this.onFocusChange.bind(this));
};

aria.ListboxButton.prototype.checkShow = function (evt) {
  const key = evt.which || evt.keyCode;

  switch (key) {
    case aria.KeyCode.UP:
    case aria.KeyCode.DOWN:
      evt.preventDefault();
      this.showListbox();
      this.listbox.checkKeyPress(evt);
      break;
  }
};

aria.ListboxButton.prototype.checkHide = function (evt) {
  const key = evt.which || evt.keyCode;

  switch (key) {
    case aria.KeyCode.RETURN:
    case aria.KeyCode.ESC:
      evt.preventDefault();
      this.hideListbox();
      this.button.focus();
      break;
  }
};

aria.ListboxButton.prototype.showListbox = function () {
  this.listbox.listboxNode.classList.remove('hidden');
  this.button.setAttribute('aria-expanded', 'true');
  this.listbox.listboxNode.focus();
};

aria.ListboxButton.prototype.hideListbox = function () {
  this.listbox.listboxNode.classList.add('hidden');
  this.button.removeAttribute('aria-expanded');
};

aria.ListboxButton.prototype.onFocusChange = function (focusedItem) {
  this.button.innerText = focusedItem.innerText;
  this.resetAriaSelected();
  focusedItem.setAttribute('aria-selected', true);
};

aria.ListboxButton.prototype.resetAriaSelected = function () {
  const itemList = this.listbox.listboxNode.querySelectorAll('[role="option"]');
  itemList.forEach(($item) => $item.setAttribute('aria-selected', false));
};

/**
 * @desc
 *  If there is no activeDescendant, focus on the first option
 */
aria.Listbox.prototype.setupFocus = function () {
  if (this.activeDescendant) {
    return;
  }

  this.focusFirstItem();
};

/**
 * @desc
 *  Focus on the first option
 */
aria.Listbox.prototype.focusFirstItem = function () {
  const firstItem = this.listboxNode.querySelector('[role="option"]');

  if (firstItem) {
    this.focusItem(firstItem);
  }
};

/**
 * @desc
 *  Focus on the last option
 */
aria.Listbox.prototype.focusLastItem = function () {
  const itemList = this.listboxNode.querySelectorAll('[role="option"]');

  if (itemList.length) {
    this.focusItem(itemList[itemList.length - 1]);
  }
};

/**
 * @desc
 *  Handle various keyboard controls; UP/DOWN will shift focus; SPACE selects
 *  an item.
 *
 * @param evt
 *  The keydown event object
 */
aria.Listbox.prototype.checkKeyPress = function (evt) {
  const key = evt.which || evt.keyCode;
  let nextItem = document.getElementById(this.activeDescendant);

  if (!nextItem) {
    return;
  }

  switch (key) {
    case aria.KeyCode.PAGE_UP:
    case aria.KeyCode.PAGE_DOWN:
      if (this.moveUpDownEnabled) {
        evt.preventDefault();

        if (key === aria.KeyCode.PAGE_UP) {
          this.moveUpItems();
        } else {
          this.moveDownItems();
        }
      }

      break;
    case aria.KeyCode.UP:
    case aria.KeyCode.DOWN:
      evt.preventDefault();

      if (this.moveUpDownEnabled && evt.altKey) {
        if (key === aria.KeyCode.UP) {
          this.moveUpItems();
        } else {
          this.moveDownItems();
        }
        return;
      }

      if (key === aria.KeyCode.UP) {
        nextItem = nextItem.previousElementSibling;
      } else {
        nextItem = nextItem.nextElementSibling;
      }

      if (nextItem) {
        this.focusItem(nextItem);
      }

      break;
    case aria.KeyCode.HOME:
      evt.preventDefault();
      this.focusFirstItem();
      break;
    case aria.KeyCode.END:
      evt.preventDefault();
      this.focusLastItem();
      break;
    case aria.KeyCode.SPACE:
      evt.preventDefault();
      this.toggleSelectItem(nextItem);
      break;
    case aria.KeyCode.BACKSPACE:
    case aria.KeyCode.DELETE:
    case aria.KeyCode.RETURN:
      if (!this.moveButton) {
        return;
      }

      // eslint-disable-next-line no-case-declarations
      const keyshortcuts = this.moveButton.getAttribute('aria-keyshortcuts');
      if (key === aria.KeyCode.RETURN && keyshortcuts.indexOf('Enter') === -1) {
        return;
      }
      if (
        (key === aria.KeyCode.BACKSPACE || key === aria.KeyCode.DELETE) &&
        keyshortcuts.indexOf('Delete') === -1
      ) {
        return;
      }

      evt.preventDefault();

      // eslint-disable-next-line no-case-declarations
      let nextUnselected = nextItem.nextElementSibling;
      while (nextUnselected) {
        if (nextUnselected.getAttribute('aria-selected') !== 'true') {
          break;
        }
        nextUnselected = nextUnselected.nextElementSibling;
      }
      if (!nextUnselected) {
        nextUnselected = nextItem.previousElementSibling;
        while (nextUnselected) {
          if (nextUnselected.getAttribute('aria-selected') !== 'true') {
            break;
          }
          nextUnselected = nextUnselected.previousElementSibling;
        }
      }

      this.moveItems();

      if (!this.activeDescendant && nextUnselected) {
        this.focusItem(nextUnselected);
      }
      break;
    default:
      // eslint-disable-next-line no-case-declarations
      const itemToFocus = this.findItemToFocus(key);
      if (itemToFocus) {
        this.focusItem(itemToFocus);
      }
      break;
  }
};

aria.Listbox.prototype.findItemToFocus = function (key) {
  const itemList = this.listboxNode.querySelectorAll('[role="option"]');
  const character = String.fromCharCode(key);

  if (!this.keysSoFar) {
    for (var i = 0; i < itemList.length; i++) {
      if (itemList[i].getAttribute('id') == this.activeDescendant) {
        this.searchIndex = i;
      }
    }
  }
  this.keysSoFar += character;
  this.clearKeysSoFarAfterDelay();

  let nextMatch = this.findMatchInRange(
    itemList,
    this.searchIndex + 1,
    itemList.length,
  );
  if (!nextMatch) {
    nextMatch = this.findMatchInRange(itemList, 0, this.searchIndex);
  }
  return nextMatch;
};

aria.Listbox.prototype.clearKeysSoFarAfterDelay = function () {
  if (this.keyClear) {
    clearTimeout(this.keyClear);
    this.keyClear = null;
  }
  this.keyClear = setTimeout(
    function () {
      this.keysSoFar = '';
      this.keyClear = null;
    }.bind(this),
    500
  );
};

aria.Listbox.prototype.findMatchInRange = function (
  list,
  startIndex,
  endIndex
) {
  // Find the first item starting with the keysSoFar substring, searching in
  // the specified range of items
  for (var n = startIndex; n < endIndex; n++) {
    var label = list[n].innerText;
    if (label && label.toUpperCase().indexOf(this.keysSoFar) === 0) {
      return list[n];
    }
  }
  return null;
};

/**
 * @desc
 *  Check if an item is clicked on. If so, focus on it and select it.
 *
 * @param evt
 *  The click event object
 */
aria.Listbox.prototype.checkClickItem = function (evt) {
  if (evt.target.getAttribute('role') === 'option') {
    this.focusItem(evt.target);
    this.toggleSelectItem(evt.target);
    if (this.listboxButton) {
      this.listboxButton.hideListbox();
    }
  }
};

/**
 * @desc
 *  Toggle the aria-selected value
 *
 * @param element
 *  The element to select
 */
aria.Listbox.prototype.toggleSelectItem = function (element) {
  if (this.multiselectable) {
    element.setAttribute(
      'aria-selected',
      element.getAttribute('aria-selected') === 'true' ? 'false' : 'true'
    );

    if (this.moveButton) {
      if (this.listboxNode.querySelector('[aria-selected="true"]')) {
        this.moveButton.setAttribute('aria-disabled', 'false');
      } else {
        this.moveButton.setAttribute('aria-disabled', 'true');
      }
    }
  }
};

/**
 * @desc
 *  Defocus the specified item
 *
 * @param element
 *  The element to defocus
 */
aria.Listbox.prototype.defocusItem = function (element) {
  if (!element) {
    return;
  }

  element.classList.remove('focused');
};

/**
 * @desc
 *  Focus on the specified item
 *
 * @param element
 *  The element to focus
 */
aria.Listbox.prototype.focusItem = function (element) {
  this.defocusItem(document.getElementById(this.activeDescendant));
  element.classList.add('focused')
  this.listboxNode.setAttribute('aria-activedescendant', element.id);
  this.activeDescendant = element.id;

  if (this.listboxNode.scrollHeight > this.listboxNode.clientHeight) {
    var scrollBottom =
      this.listboxNode.clientHeight + this.listboxNode.scrollTop;
    var elementBottom = element.offsetTop + element.offsetHeight;
    if (elementBottom > scrollBottom) {
      this.listboxNode.scrollTop =
        elementBottom - this.listboxNode.clientHeight;
    } else if (element.offsetTop < this.listboxNode.scrollTop) {
      this.listboxNode.scrollTop = element.offsetTop;
    }
  }

  if (!this.multiselectable && this.moveButton) {
    this.moveButton.setAttribute('aria-disabled', false);
  }

  this.checkUpDownButtons();
  this.handleFocusChange(element);
};

/**
 * @desc
 *  Enable/disable the up/down arrows based on the activeDescendant.
 */
aria.Listbox.prototype.checkUpDownButtons = function () {
  var activeElement = document.getElementById(this.activeDescendant);

  if (!this.moveUpDownEnabled) {
    return false;
  }

  if (!activeElement) {
    this.upButton.setAttribute('aria-disabled', 'true');
    this.downButton.setAttribute('aria-disabled', 'true');
    return;
  }

  if (this.upButton) {
    if (activeElement.previousElementSibling) {
      this.upButton.setAttribute('aria-disabled', false);
    } else {
      this.upButton.setAttribute('aria-disabled', 'true');
    }
  }

  if (this.downButton) {
    if (activeElement.nextElementSibling) {
      this.downButton.setAttribute('aria-disabled', false);
    } else {
      this.downButton.setAttribute('aria-disabled', 'true');
    }
  }
};

/**
 * @desc
 *  Add the specified items to the listbox. Assumes items are valid options.
 *
 * @param items
 *  An array of items to add to the listbox
 */
aria.Listbox.prototype.addItems = function (items) {
  if (!items || !items.length) {
    return false;
  }

  items.forEach(
    function (item) {
      this.defocusItem(item);
      this.toggleSelectItem(item);
      this.listboxNode.append(item);
    }.bind(this)
  );

  if (!this.activeDescendant) {
    this.focusItem(items[0]);
  }

  this.handleItemChange('added', items);
};

/**
 * @desc
 *  Remove all of the selected items from the listbox; Removes the focused items
 *  in a single select listbox and the items with aria-selected in a multi
 *  select listbox.
 *
 * @returns items
 *  An array of items that were removed from the listbox
 */
aria.Listbox.prototype.deleteItems = function () {
  var itemsToDelete;

  if (this.multiselectable) {
    itemsToDelete = this.listboxNode.querySelectorAll('[aria-selected="true"]');
  } else if (this.activeDescendant) {
    itemsToDelete = [document.getElementById(this.activeDescendant)];
  }

  if (!itemsToDelete || !itemsToDelete.length) {
    return [];
  }

  itemsToDelete.forEach(
    function (item) {
      item.remove();

      if (item.id === this.activeDescendant) {
        this.clearActiveDescendant();
      }
    }.bind(this)
  );

  this.handleItemChange('removed', itemsToDelete);

  return itemsToDelete;
};

aria.Listbox.prototype.clearActiveDescendant = function () {
  this.activeDescendant = null;
  this.listboxNode.setAttribute('aria-activedescendant', null);

  if (this.moveButton) {
    this.moveButton.setAttribute('aria-disabled', 'true');
  }

  this.checkUpDownButtons();
};

/**
 * @desc
 *  Shifts the currently focused item up on the list. No shifting occurs if the
 *  item is already at the top of the list.
 */
aria.Listbox.prototype.moveUpItems = function () {
  var previousItem;

  if (!this.activeDescendant) {
    return;
  }

  currentItem = document.getElementById(this.activeDescendant);
  previousItem = currentItem.previousElementSibling;

  if (previousItem) {
    this.listboxNode.insertBefore(currentItem, previousItem);
    this.handleItemChange('moved_up', [currentItem]);
  }

  this.checkUpDownButtons();
};

/**
 * @desc
 *  Shifts the currently focused item down on the list. No shifting occurs if
 *  the item is already at the end of the list.
 */
aria.Listbox.prototype.moveDownItems = function () {
  var nextItem;

  if (!this.activeDescendant) {
    return;
  }

  currentItem = document.getElementById(this.activeDescendant);
  nextItem = currentItem.nextElementSibling;

  if (nextItem) {
    this.listboxNode.insertBefore(nextItem, currentItem);
    this.handleItemChange('moved_down', [currentItem]);
  }

  this.checkUpDownButtons();
};

/**
 * @desc
 *  Delete the currently selected items and add them to the sibling list.
 */
aria.Listbox.prototype.moveItems = function () {
  if (!this.siblingList) {
    return;
  }

  var itemsToMove = this.deleteItems();
  this.siblingList.addItems(itemsToMove);
};

/**
 * @desc
 *  Enable Up/Down controls to shift items up and down.
 *
 * @param upButton
 *   Up button to trigger up shift
 *
 * @param downButton
 *   Down button to trigger down shift
 */
aria.Listbox.prototype.enableMoveUpDown = function (upButton, downButton) {
  this.moveUpDownEnabled = true;
  this.upButton = upButton;
  this.downButton = downButton;
  upButton.addEventListener('click', this.moveUpItems.bind(this));
  downButton.addEventListener('click', this.moveDownItems.bind(this));
};

/**
 * @desc
 *  Enable Move controls. Moving removes selected items from the current
 *  list and adds them to the sibling list.
 *
 * @param button
 *   Move button to trigger delete
 *
 * @param siblingList
 *   Listbox to move items to
 */
aria.Listbox.prototype.setupMove = function (button, siblingList) {
  this.siblingList = siblingList;
  this.moveButton = button;
  button.addEventListener('click', this.moveItems.bind(this));
};

aria.Listbox.prototype.setHandleItemChange = function (handlerFn) {
  this.handleItemChange = handlerFn;
};

aria.Listbox.prototype.setHandleFocusChange = function (focusChangeHandler) {
  this.handleFocusChange = focusChangeHandler;
};

// --------------------------------

window.theme = window.theme || {};

window.theme.config = {
  isTouch: !!(
    'ontouchstart' in window ||
    (window.DocumentTouch && window.document instanceof DocumentTouch) ||
    window.navigator.maxTouchPoints ||
    window.navigator.msMaxTouchPoints
  ),
};

if (window.theme.config.isTouch) {
  document.documentElement.className += ' supports-touch';
}

/* ================ Theme Editor API ================ */
window.theme = window.theme || {};

// console.log('in global ', window.theme);

window.theme.delegate = {
  on(event, callback, options) {
    if (!this.namespaces) {
      // save the namespaces on the DOM element itself
      this.namespaces = {};
    }

    this.namespaces[event] = callback;
    options = options || false;

    this.addEventListener(event.split('.')[0], callback, options);
    return this;
  },
  off(event) {
    if (!this.namespaces) {
      return;
    }
    this.removeEventListener(event.split('.')[0], this.namespaces[event]);
    delete this.namespaces[event];
    return this;
  },
};

// Extend the DOM with these above custom methods
window.on = Element.prototype.on = window.theme.delegate.on;
window.off = Element.prototype.off = window.theme.delegate.off;

window.theme.utils = {
  defaultTo(value, defaultValue) {
    return value == null || value !== value ? defaultValue : value;
  },

  wrap(el, wrapper) {
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  },

  debounce(wait, callback, immediate) {
    let timeout;
    return function () {
      const context = this;
      const args = arguments;
      const later = function () {
        timeout = null;
        if (!immediate) callback.apply(context, args);
      };
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) callback.apply(context, args);
    };
  },

  throttle(limit, callback) {
    let waiting = false;
    return function () {
      if (!waiting) {
        callback.apply(this, arguments);
        waiting = true;
        setTimeout(() => {
          waiting = false;
        }, limit);
      }
    };
  },

  prepareTransition(el, callback) {
    el.addEventListener('transitionend', removeClass);

    function removeClass(evt) {
      el.classList.remove('is-transitioning');
      el.removeEventListener('transitionend', removeClass);
    }

    el.classList.add('is-transitioning');
    el.offsetWidth; // check offsetWidth to force the style rendering

    if (typeof callback === 'function') {
      callback();
    }
  },

  // _.compact from lodash
  // Creates an array with all falsey values removed. The values `false`, `null`,
  // `0`, `""`, `undefined`, and `NaN` are falsey.
  // _.compact([0, 1, false, 2, '', 3]);
  // => [1, 2, 3]
  compact(array) {
    let index = -1;
    const length = array == null ? 0 : array.length;
    let resIndex = 0;
    const result = [];

    while (++index < length) {
      const value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  serialize(form) {
    const arr = [];
    Array.prototype.slice.call(form.elements).forEach((field) => {
      if (
        !field.name ||
        field.disabled ||
        ['file', 'reset', 'submit', 'button'].indexOf(field.type) > -1
      )
        return;
      if (field.type === 'select-multiple') {
        Array.prototype.slice.call(field.options).forEach((option) => {
          if (!option.selected) return;
          arr.push(
            `${encodeURIComponent(field.name)}=${encodeURIComponent(
              option.value
            )}`
          );
        });
        return;
      }
      if (['checkbox', 'radio'].indexOf(field.type) > -1 && !field.checked)
        return;
      arr.push(
        `${encodeURIComponent(field.name)}=${encodeURIComponent(field.value)}`
      );
    });
    return arr.join('&');
  },
};

window.theme.a11y = {
  trapFocus(options) {
    const eventsName = {
      focusin: options.namespace ? `focusin.${options.namespace}` : 'focusin',
      focusout: options.namespace
        ? `focusout.${options.namespace}`
        : 'focusout',
      keydown: options.namespace
        ? `keydown.${options.namespace}`
        : 'keydown.handleFocus',
    };

    // Get every possible visible focusable element
    const focusableEls = options.container.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex^="-"])',
    );
    const elArray = [].slice.call(focusableEls);
    const focusableElements = elArray.filter((el) => el.offsetParent !== null);

    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];

    if (!options.elementToFocus) {
      options.elementToFocus = options.container;
    }

    options.container.setAttribute('tabindex', '-1');
    options.elementToFocus.focus();

    document.documentElement.off('focusin');
    document.documentElement.on(eventsName.focusout, () => {
      document.documentElement.off(eventsName.keydown);
    });

    document.documentElement.on(eventsName.focusin, (evt) => {
      if (evt.target !== lastFocusable && evt.target !== firstFocusable) return;

      document.documentElement.on(eventsName.keydown, (evt) => {
        _manageFocus(evt);
      });
    });

    function _manageFocus(evt) {
      if (evt.keyCode !== 9) return;
      /**
       * On the first focusable element and tab backward,
       * focus the last element
       */
      if (evt.target === firstFocusable && evt.shiftKey) {
        evt.preventDefault();
        lastFocusable.focus();
      }

      if (evt.target === lastFocusable && !evt.shiftKey) {
        evt.preventDefault();
        firstFocusable.focus();
      }
    }
  },

  removeTrapFocus(options) {
    const eventName = options.namespace
      ? `focusin.${options.namespace}`
      : 'focusin';

    if (options.container) {
      options.container.removeAttribute('tabindex');
    }

    document.documentElement.off(eventName);
  },

  lockMobileScrolling(namespace, element) {
    const el = element || document.documentElement;
    document.documentElement.classList.add('lock-scroll');
    el.on(`touchmove${namespace}`, () => true);
  },

  unlockMobileScrolling(namespace, element) {
    document.documentElement.classList.remove('lock-scroll');
    const el = element || document.documentElement;
    el.off(`touchmove${namespace}`);
  },
};

window.theme.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  document.addEventListener(
    'shopify:section:load',
    this._onSectionLoad.bind(this)
  );
  document.addEventListener(
    'shopify:section:unload',
    this._onSectionUnload.bind(this)
  );
  document.addEventListener(
    'shopify:section:select',
    this._onSelect.bind(this)
  );
  document.addEventListener(
    'shopify:section:deselect',
    this._onDeselect.bind(this)
  );
  document.addEventListener(
    'shopify:block:select',
    this._onBlockSelect.bind(this)
  );
  document.addEventListener(
    'shopify:block:deselect',
    this._onBlockDeselect.bind(this)
  );
};

window.theme.Sections.prototype = {
  ...window.theme.Sections.prototype,
  _createInstance(container, constructor) {
    const id = container.getAttribute('data-section-id');
    const type = container.getAttribute('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    const instance = Object.assign(new constructor(container), {
      id,
      type,
      container,
    });

    this.instances.push(instance);
  },

  _onSectionLoad(evt) {
    const container = document.querySelector(
      `[data-section-id="${evt.detail.sectionId}"]`
    );

    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload(evt) {
    this.instances = this.instances.filter((instance) => {
      const isEventInstance = instance.id === evt.detail.sectionId;

      if (isEventInstance) {
        if (typeof instance.onUnload === 'function') {
          instance.onUnload(evt);
        }
      }

      return !isEventInstance;
    });
  },

  _onSelect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = this.instances.find(
      (instance) => instance.id === evt.detail.sectionId
    );

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onSelect === 'function'
    ) {
      instance.onSelect(evt);
    }
  },

  _onDeselect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = this.instances.find(
      (instance) => instance.id === evt.detail.sectionId
    );

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onDeselect === 'function'
    ) {
      instance.onDeselect(evt);
    }
  },

  _onBlockSelect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = this.instances.find(
      (instance) => instance.id === evt.detail.sectionId
    );

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockSelect === 'function'
    ) {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect(evt) {
    // eslint-disable-next-line no-shadow
    const instance = this.instances.find(
      (instance) => instance.id === evt.detail.sectionId
    );

    if (
      typeof instance !== 'undefined' &&
      typeof instance.onBlockDeselect === 'function'
    ) {
      instance.onBlockDeselect(evt);
    }
  },

  register(type, constructor) {
    this.constructors[type] = constructor;

    document
      .querySelectorAll(`[data-section-type="${type}"]`)
      .forEach((container) => {
        this._createInstance(container, constructor);
      });
  },
};

window.theme.Dom = (function () {
  /**
   * Get all the previous and next siblings, optionally filtered by a selector
   */
  function getSiblings(element, filter) {
    const includeSelf =
      arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    const siblings = [];
    let currentElement = element; // Do the previous first

    while ((currentElement = currentElement.previousElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    if (includeSelf) {
      siblings.push(element);
    } // Then the next side

    currentElement = element;

    while ((currentElement = currentElement.nextElementSibling)) {
      if (!filter || currentElement.matches(filter)) {
        siblings.push(currentElement);
      }
    }

    return siblings;
  }

  /**
   * By default, NodeList object are only iterable with forEach on newest browsers. To support it cross-browser,
   * we need to normalize it
   */
  function nodeListToArray(nodeList, filter) {
    const items = [];

    for (let i = 0; i !== nodeList.length; ++i) {
      if (!filter || nodeList[i].matches(filter)) {
        items.push(nodeList[i]);
      }
    }

    return items;
  }

  /**
   * Calculate an element width with its margin
   */
  function outerWidthWithMargin(element) {
    let width = element.offsetWidth;
    const style = getComputedStyle(element);
    width += parseInt(style.marginLeft) + parseInt(style.marginRight);
    return width;
  }

  /**
   * Calculate an element height with its margin
   */
  function outerHeightWithMargin(element) {
    let height = element.offsetHeight;
    const style = getComputedStyle(element);
    height += parseInt(style.marginTop) + parseInt(style.marginBottom);
    return height;
  }

  return {
    getSiblings,
    nodeListToArray,
    outerWidthWithMargin,
    outerHeightWithMargin,
  };
})();

window.theme.Modals = (function () {
  function Modal(id, name, options) {
    const defaults = {
      close: '.js-modal-close',
      open: `.js-modal-open-${name}`,
      openClass: 'modal--is-active',
      closingClass: 'modal--is-closing',
      bodyOpenClass: 'modal-open',
      bodyOpenSolidClass: 'modal-open--solid',
      bodyClosingClass: 'modal-closing',
      closeOffContentClick: true,
      removeBodyClassOnClose: true,
    };

    this.id = id;
    this.modal = document.getElementById(id);

    if (!this.modal) {
      return false;
    }

    this.modalContent = this.modal.querySelector('.modal__inner');

    this.config = Object.assign(defaults, options);
    this.modalIsOpen = false;
    this.focusOnOpen = this.config.focusIdOnOpen
      ? document.getElementById(this.config.focusIdOnOpen)
      : this.modal;
    this.isSolid = this.config.solid;

    this.init();
  }

  Modal.prototype.init = function () {
    document.querySelectorAll(this.config.open).forEach((btn) => {
      btn.setAttribute('aria-expanded', 'false');
      btn.addEventListener('click', this.open.bind(this));
    });

    this.modal.querySelectorAll(this.config.close).forEach((btn) => {
      btn.addEventListener('click', this.close.bind(this));
    });

    // Close modal if a drawer is opened
    document.addEventListener('drawerOpen', () => {
      this.close();
    });
  };

  Modal.prototype.removeOpenTrigger = function () {
    document.querySelectorAll(this.config.open).forEach((btn) => {
      // Remove event listener by cloning the node
      btn.replaceWith(btn.cloneNode(true));
    });
  };

  Modal.prototype.open = function (evt) {
    if (this.modal.id === 'bopisSearchModal') {
      const bopisScriptElement = document.getElementById('bopisMapScript');
      if (bopisScriptElement) {
        const existingScript = bopisScriptElement.querySelector('script');
        if (!existingScript) {
          const { scriptSrc } = bopisScriptElement.dataset;
          const script = document.createElement('script');
          script.src = scriptSrc;
          script.defer = true;
          bopisScriptElement.appendChild(script);
        }
      }
    }

    // Keep track if modal was opened from a click, or called by another function
    let externalCall = false;

    // don't open an opened modal
    if (this.modalIsOpen) {
      return;
    }

    // Prevent following href if link is clicked
    if (evt) {
      evt.preventDefault();
    } else {
      externalCall = true;
    }

    // Without this, the modal opens, the click event bubbles up to $nodes.page
    // which closes the modal.
    if (evt && evt.stopPropagation) {
      evt.stopPropagation();
      // save the source of the click, we'll focus to this on close
      this.activeSource = evt.currentTarget.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    if (this.modalIsOpen && !externalCall) {
      this.close();
    }

    this.modal.classList.add(this.config.openClass);

    document.documentElement.classList.add(this.config.bodyOpenClass);

    if (this.isSolid) {
      document.documentElement.classList.add(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = true;

    window.theme.a11y.trapFocus({
      container: this.modal,
      elementToFocus: this.focusOnOpen,
      namespace: 'modal_focus',
    });

    document.dispatchEvent(new CustomEvent('modalOpen'));
    document.dispatchEvent(new CustomEvent(`modalOpen.${this.id}`));

    this.bindEvents();
  };

  Modal.prototype.close = function (evt) {
    // don't close a closed modal
    if (!this.modalIsOpen) {
      return;
    }

    // Do not close modal if click happens inside modal content
    if (evt) {
      if (evt.target.closest('.js-modal-close')) {
        // Do not close if using the modal close button
      } else if (evt.target.closest('.modal__inner')) {
        return;
      }
    }

    // deselect any focused form elements
    document.activeElement.blur();

    this.modal.classList.remove(this.config.openClass);
    this.modal.classList.add(this.config.closingClass);

    if (this.config.removeBodyClassOnClose) {
      document.documentElement.classList.remove(this.config.bodyOpenClass);
      document.documentElement.classList.add(this.config.bodyClosingClass);
    }

    window.setTimeout(() => {
      document.documentElement.classList.remove(this.config.bodyClosingClass);
      this.modal.classList.remove(this.config.closingClass);
      if (
        this.activeSource &&
        this.activeSource.getAttribute('aria-expanded')
      ) {
        this.activeSource.setAttribute('aria-expanded', 'false').focus();
      }
    }, 500); // modal close css transition

    if (this.isSolid) {
      document.documentElement.classList.remove(this.config.bodyOpenSolidClass);
    }

    this.modalIsOpen = false;

    window.theme.a11y.removeTrapFocus({
      container: this.modal,
      namespace: 'modal_focus',
    });

    document.dispatchEvent(new CustomEvent(`modalClose.${this.id}`));

    this.unbindEvents();
  };

  Modal.prototype.bindEvents = function () {
    window.on('keyup.modal', (evt) => {
      if (evt.keyCode === 27) {
        this.close();
      }
    });

    if (this.config.closeOffContentClick) {
      // Clicking outside of the modal content also closes it
      this.modal.on('click.modal', this.close.bind(this));
    }
  };

  Modal.prototype.unbindEvents = function () {
    document.documentElement.off('.modal');

    if (this.config.closeOffContentClick) {
      this.modal.off('.modal');
    }
  };

  return Modal;
})();

window.theme.Drawers = (function () {
  function Drawers(id, name) {
    this.config = {
      id,
      close: '.js-drawer-close',
      open: `.js-drawer-open-${name}`,
      openClass: 'js-drawer-open',
      closingClass: 'js-drawer-closing',
      activeDrawer: 'drawer--is-open',
      namespace: `.drawer-${name}`,
    };

    this.nodes = {
      page: document.querySelector('#MainContent'),
    };

    this.drawer = document.querySelector(`#${id}`);
    this.isOpen = false;

    if (!this.drawer) {
      return;
    }

    this.init();
  }

  Drawers.prototype = {
    ...Drawers.prototype,
    init() {
      // Setup open button(s)
      document.querySelectorAll(this.config.open).forEach((openBtn) => {
        if (openBtn.id !== "cart-icon-bubble") {
          openBtn.setAttribute('aria-expanded', 'false');
        }
        openBtn.addEventListener('click', this.open.bind(this));
      });

      this.drawer
        .querySelector(this.config.close)
        .addEventListener('click', this.close.bind(this));

      // Close modal if a drawer is opened
      document.addEventListener('modalOpen', () => {
        this.close();
      });
    },

    open(evt, returnFocusEl) {
      if (evt) {
        evt.preventDefault();
      }

      if (this.isOpen) {
        return;
      }

      // Without this the drawer opens, the click event bubbles up to $nodes.page which closes the drawer.
      if (evt && evt.stopPropagation) {
        evt.stopPropagation();
        // save the source of the click, we'll focus to this on close
        if (evt.currentTarget.id !== "cart-icon-bubble") {
          evt.currentTarget.setAttribute('aria-expanded', 'true');
        }
        this.activeSource = evt.currentTarget;
      } else if (returnFocusEl) {
        returnFocusEl.setAttribute('aria-expanded', 'true');
        this.activeSource = returnFocusEl;
      }

      window.theme.utils.prepareTransition(this.drawer, () => {
        this.drawer.classList.add(this.config.activeDrawer);
      });

      document.documentElement.classList.add(this.config.openClass);
      this.isOpen = true;

      window.theme.a11y.trapFocus({
        container: this.drawer,
        namespace: 'drawer_focus',
      });

      document.dispatchEvent(new CustomEvent('drawerOpen'));
      document.dispatchEvent(new CustomEvent(`drawerOpen.${this.config.id}`));

      this.bindEvents();
    },

    close(evt) {
      if (!this.isOpen) {
        return;
      }

      // Do not close if click event came from inside drawer
      if (evt) {
        if (evt.target.closest('.js-drawer-close')) {
          // Do not close if using the drawer close button
        } else if (evt.target.closest('.drawer')) {
          return;
        }
      }

      // deselect any focused form elements
      document.activeElement.blur();

      window.theme.utils.prepareTransition(this.drawer, () => {
        this.drawer.classList.remove(this.config.activeDrawer);
      });

      document.documentElement.classList.remove(this.config.openClass);
      document.documentElement.classList.add(this.config.closingClass);

      window.setTimeout(() => {
        document.documentElement.classList.remove(this.config.closingClass);
        if (
          this.activeSource &&
          this.activeSource.getAttribute('aria-expanded')
        ) {
          if (this.activeSource.id !== "cart-icon-bubble") {
            this.activeSource.setAttribute('aria-expanded', 'false');
          }
          this.activeSource.focus();
        }
      }, 500);

      this.isOpen = false;

      window.theme.a11y.removeTrapFocus({
        container: this.drawer,
        namespace: 'drawer_focus',
      });

      this.unbindEvents();
    },

    bindEvents() {
      // Clicking out of drawer closes it
      window.on(`click${this.config.namespace}`, (evt) => {
        if(evt && evt.target && evt.target.classList.contains('js-embroidery-close')) {
          return;
        }
        this.close(evt);
      });

      // Pressing escape closes drawer
      window.on(`keyup${this.config.namespace}`, (evt) => {
        if (evt.keyCode === 27) {
          this.close();
        }
      });

      window.theme.a11y.lockMobileScrolling(
        this.config.namespace,
        this.nodes.page
      );
    },

    unbindEvents() {
      window.off(`click${this.config.namespace}`);
      window.off(`keyup${this.config.namespace}`);

      window.theme.a11y.unlockMobileScrolling(
        this.config.namespace,
        this.nodes.page
      );
    },
  };

  return Drawers;
})();

// Dawn Script Starts Here

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details').hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  const elements = getFocusableElements(container);
  const first = elements[0];
  const last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    ) {
      return;
    }

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    if (window.checkout.enableLimit && window.checkout.variantMax) {
      const quantity = event.target.getAttribute('data-quantity');
      const $limitModal = document.querySelector('.js-limit-modal');
      if (quantity >= window.checkout.variantMax) {
        if ($limitModal) $limitModal.classList.toggle('modal--is-active');
        return;
      }
    }

    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
  }
}
customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify === 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (let i = 0, count = selector.options.length; i < count; i++) {
    const option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent(`on${eventName}`, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  const method = options.method || 'post';
  const params = options.parameters || {};

  const form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (const key in params) {
    const hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone')
      document.documentElement.style.setProperty(
        '--viewport-height',
        `${window.innerHeight}px`
      );

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    // this.querySelectorAll('.mobile-facet-item.filter').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onCloseButtonClick.bind(this))
    );
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    const clickTarget = event.target;

    const clickTargetWidth = window.innerWidth;
    const xCoordInClickTarget = event.clientX;
    const yCoordInClickTarget = event.clientY;
    const summaryClickTarget = window.innerHeight - 50;
    const registerClicksIn = yCoordInClickTarget;

    if (yCoordInClickTarget >= summaryClickTarget) {
      if (clickTargetWidth / 2 > xCoordInClickTarget) {
        // clicked left
        // console.log('clicked filter ');
        document.querySelector('.mobile-facets__close').style.display = 'flex';
        if (detailsElement === this.mainDetailsToggle) {
          if (isOpen) {
            event.preventDefault();
            // console.log('after is open is true if, going to close.');
          }
          isOpen
            ? this.closeMenuDrawer(event, summaryElement)
            : this.openMenuDrawer(summaryElement);
          if (
            document
              .querySelector('.mobile-sort__pane')
              .classList.contains('show-pane')
          ) {
            // console.log('removing sort');
            document
              .querySelector('.mobile-sort__pane')
              .classList.remove('show-pane');
          }
        } else {
          setTimeout(() => {
            detailsElement.classList.add('menu-opening');
            summaryElement.setAttribute('aria-expanded', true);
            !reducedMotion || reducedMotion.matches
              ? addTrapFocus()
              : summaryElement.nextElementSibling.addEventListener(
                  'transitionend',
                  addTrapFocus
                );
          }, 100);
        }
      } else {
        // clicked right
        // console.log('clicked sort ');
        document
          .querySelector('.mobile-sort__pane')
          .classList.toggle('show-pane');
      }
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    // console.log('in close drawer');
    document.querySelector('.mobile-facets__close').style.display = 'none';
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}
customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}
customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}
customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.sliderPoints = this.querySelectorAll(
      '.slider-points .slider-points__item'
    );

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
        this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.sliderPoints.forEach((e) => {
      const pointPosition = parseInt(e.getAttribute('data-media-position'));
      e.removeAttribute('aria-current');
      if (pointPosition == this.currentPage)
        e.setAttribute('aria-current', true);
    });
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}
customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll('.slider-counter__link')
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener('click', this.linkToSlide.bind(this))
    );
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true')
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}
customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.renderProductInfoMobile();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(
      (variant) =>
        !variant.options
          .map((option, index) => this.options[index] === option)
          .includes(false)
    );
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState(
      {},
      '',
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        const klarnaPlacement = document.querySelector('klarna-placement');
        if (klarnaPlacement) {
          const variantPrice = document
            .querySelector('.product .price')
            .getAttribute('data-price');
          document
            .querySelector('klarna-placement')
            .setAttribute('data-purchase-amount', variantPrice);
          window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }

        const colorName = document.getElementById('colorValue');
        if (colorName) {
          const currentColor = document
            .querySelector('#colorPills .color-radio:checked')
            .getAttribute('value');
          colorName.innerText = currentColor;
        }
      });
  }

  renderProductInfoMobile() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const id_m = `price-${this.dataset.section}-mobile`;
        const html_m = new DOMParser().parseFromString(
          responseText,
          'text/html'
        );
        const destination_m = document.getElementById(id_m);
        const source_m = html_m.getElementById(id_m);

        if (source_m && destination_m)
          destination_m.innerHTML = source_m.innerHTML;

        const price_m = document.getElementById(
          `price-${this.dataset.section}-mobile`
        );

        if (price_m) price_m.classList.remove('visibility-hidden');
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );

        const klarnaPlacement = document.querySelector('klarna-placement');
        if (klarnaPlacement) {
          const variantPrice = document
            .querySelector('.product .price')
            .getAttribute('data-price');
          document
            .querySelector('klarna-placement')
            .setAttribute('data-purchase-amount', variantPrice);
          window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
          window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (addButtonText && text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      if (addButtonText) addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    if (addButtonText) addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('.fieldset'));
    this.options = fieldsets.map((fieldset) => {
      // adjust selected variant if klaviyo bis is enabled
      if (document.querySelector('.klaviyo-bis-trigger')) {
        const inputValue = document.querySelector('#inputValue');
        const selectedVariantId = document.querySelector(
          '.product-form__var-input'
        ).value;
        const submitButton = document.querySelector('.product-form__submit');
        const submitButtonText = document
          .querySelector('.product-form__submit')
          .innerText.toLowerCase();

        inputValue.value = selectedVariantId;
        const pickupInStore = document.querySelector('.pickup__in-store');
        pickupInStore.setAttribute('data-variant-id', selectedVariantId);
        if (submitButtonText === 'out of stock') {
          submitButton.style.display = 'none';
        } else {
          submitButton.style.display = 'block';
          submitButton.removeAttribute('disabled');
        }
      }
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}
customElements.define('variant-radios', VariantRadios);

class RecentlyViewedProduct extends HTMLElement {
  constructor() {
    super();

    this.element = this;

    this.options = JSON.parse(
      this.element.getAttribute('data-section-settings')
    );

    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      this.fetchProducts();
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 200px 0px',
    }).observe(this);
  }

  fetchProducts() {
    const _this = this;

    const queryString = this.getSearchQueryString();

    if (queryString === '') {
      return;
    } // If we have a non empty query string we do a search query

    const searchUrl = window.routes.searchUrl || '/pages/search';

    fetch(
      ''
        .concat(searchUrl, '?section_id=')
        .concat(
          this.element.getAttribute('data-section-id'),
          '&type=product&q='
        )
        .concat(queryString),
      {
        credentials: 'same-origin',
        method: 'GET',
      }
    ).then((response) => {
      response.text().then((content) => {
        const tempElement = document.createElement('div');
        tempElement.innerHTML = content; // Set the content

        _this.querySelector('.Section').innerHTML =
          tempElement.querySelector('.Section').innerHTML; // Show the section

        _this.querySelector('.Section').classList.remove('hidden');

        const event = new Event('built-recents');

        // Dispatch the event.
        document.dispatchEvent(event);

        // console.log('built recents');
      });
    });
  }

  getSearchQueryString() {
    const items = JSON.parse(
      localStorage.getItem('recentlyViewedProducts') || '[]'
    ); // If we are on a product template, we make sure to remove the main product from the related product

    if (items.includes(this.options.productId)) {
      items.splice(items.indexOf(this.options.productId), 1);
    }

    return items.map((item) => `id:${item}`).join(' OR ');
  }
}
customElements.define('recently-viewed-product', RecentlyViewedProduct);

class CustomSlideshow extends SliderComponent {
  constructor() {
    super();

    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.Slideshow__slide');

    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.selectors = {
      prevButton: 'slide-prev',
      nextButton: 'slide-next',
    };

    const prevButtons = document.querySelectorAll('button[name="slide-prev"]');
    const nextButtons = document.querySelectorAll('button[name="slide-next"]');

    const _this = this;

    for (const prevButton of prevButtons) {
      prevButton.removeAttribute('disabled');

      prevButton.addEventListener('click', (event) => {
        _this.prevButton.click();
      });
    }

    for (const nextButton of nextButtons) {
      nextButton.removeAttribute('disabled');

      nextButton.addEventListener('click', (event) => {
        _this.nextButton.click();
      });
    }

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (Shopify.designMode) this.bindEditorEvents();
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      'slider-counter__link--active'
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      'aria-current',
      true
    );
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  bindEditorEvents() {
    document.addEventListener('shopify:block:select', (event) => {
      const blockSelectedIsSlide =
        event.target.classList.contains('Slideshow__slide');
      if (!blockSelectedIsSlide) return;

      const parentSlideshowComponent = event.target.closest('custom-slideshow');

      setTimeout(() => {
        parentSlideshowComponent.slider.scrollTo({
          left: event.target.offsetLeft,
        });
      }, 200);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const blockDeselectedIsSlide =
        event.target.classList.contains('slideshow__slide');
      if (!blockDeselectedIsSlide) return;
      const parentSlideshowComponent = event.target.closest('custom-slideshow');
    });
  }
}

customElements.define('custom-slideshow', CustomSlideshow);
class PromoComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('[data-slide-button]');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.promo__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (Shopify.designMode) this.bindEditorEvents();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      'click',
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.prevButton.removeAttribute('disabled');
    this.nextButton.removeAttribute('disabled');
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute(
        'aria-label',
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
          this.slider.querySelector('.promo__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) +
          1 -
          this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  bindEditorEvents() {
    document.addEventListener('shopify:block:select', (event) => {
      const blockSelectedIsSlide =
        event.target.classList.contains('promo__slide');
      if (!blockSelectedIsSlide) return;

      const parentSlideshowComponent = event.target.closest('promo-component');

      setTimeout(() => {
        parentSlideshowComponent.slider.scrollTo({
          left: event.target.offsetLeft,
        });
      }, 200);
    });

    document.addEventListener('shopify:block:deselect', (event) => {
      const blockDeselectedIsSlide =
        event.target.classList.contains('promo__slide');
      if (!blockDeselectedIsSlide) return;
      const parentSlideshowComponent = event.target.closest('promo-component');
    });
  }
}
customElements.define('promo-component', PromoComponent);


class SizeTabs extends HTMLElement {
  constructor() {
    super();

    this.element = this;

    this.selectors = {
      tabList: '[data-tablist]',
      tabLinks: '[data-action="toggle-tabs"]',
      tabContent: '[data-tabcontent]'
    }

    this.tablist = this.querySelector(this.selectors.tabList);
    this.tabs = this.querySelectorAll(this.selectors.tabLinks);
    this.tabpanels = this.querySelectorAll(this.selectors.tabContent);

    this.tabs.forEach((tab) => tab.addEventListener('click', this.onTabClick.bind(this)));
    this.tablist.addEventListener('keydown', this.onKeyDown.bind(this));
  }

  onTabClick(event) {
    event.preventDefault();
    this.selectTab(event.target);
  }

  onKeyDown(event) {
    switch(event.key) {
      case 'ArrowLeft':
        this.selectPreviousTab();
        break;
      case 'ArrowUp':
        this.selectPreviousTab();
        break;
      case 'ArrowRight':
        this.selectNextTab();
        break;
      case 'ArrowDown':
        this.selectNextTab();
        break;
      case 'Home':
        event.preventDefault();
        this.selectFirstTab();
        break;
      case 'End':
        event.preventDefault();
        this.selectLastTab();
        break;
    }
  }

  selectPreviousTab() {
    let activeTab = this.querySelector('[data-action="toggle-tabs"][aria-selected="true"]');
    let activeTabIndex = Array.prototype.indexOf.call(this.tabs, activeTab);

    if (activeTabIndex > 0) {
      this.selectTab(this.tabs[activeTabIndex - 1]);
    } else {
      this.selectTab(this.tabs[this.tabs.length - 1]);
    }
  }

  selectNextTab() {
    let activeTab = this.querySelector('[data-action="toggle-tabs"][aria-selected="true"]');
    let activeTabIndex = Array.prototype.indexOf.call(this.tabs, activeTab);

    if (activeTabIndex < this.tabs.length - 1) {
      this.selectTab(this.tabs[activeTabIndex + 1]);
    } else {
      this.selectTab(this.tabs[0]);
    }
  }

  selectFirstTab() {
    this.selectTab(this.tabs[0]);
  }

  selectLastTab() {
    this.selectTab(this.tabs[this.tabs.length - 1]);
  }

  selectTab(target) {
    let tabId = target.getAttribute('aria-controls');

    // Remove active state from all tabs
    this.tabs.forEach((tab) => {
      tab.classList.remove('Link--active');
      tab.setAttribute('aria-selected', false);
      tab.setAttribute('tabindex', -1);
    });

    // Remove current state from all tab panels
    this.tabpanels.forEach((tabpanel) => {
      tabpanel.classList.remove('is-current');
    });

    // Activate selected tab
    target.classList.add('Link--active');
    target.setAttribute('aria-selected', true);
    target.setAttribute('tabindex', 0);
    target.focus();

    // Show corresponding tab panel
    this.querySelector(`#${tabId}`).classList.add('is-current');
  }
}
customElements.define('size-tabs', SizeTabs);

// Content/Module Tab Code - Don't edit anything here
class ModuleTabs extends HTMLElement {
  constructor() {
    super();

    this.element = this;

    this.selectors = {
      tabList: '[data-list-module]',
      tabLinks: '[data-action="toggle-module"]',
      tabContent: '[data-module-content]'
    }

    this.querySelectorAll(this.selectors.tabLinks).forEach(
      (currentTab) => currentTab.addEventListener('click', this.onTabClick.bind(this))
    );
  }

  onTabClick(event) {
    event.preventDefault();
    var target = event.target;
    var tabId = target.getAttribute('aria-controls');

    // We remove active attribute from all siblings
    var targetSiblings = this.getSiblings(target);

    for (const targetSibling of targetSiblings) {
      targetSibling.classList.remove('active');
    }

    // We remove current attribute from all content tabs
    var tabContents = this.querySelectorAll(this.selectors.tabContent);
    for (const tabContent of tabContents) {
      tabContent.classList.remove('is-active');
    }

    target.classList.add('active');
    this.querySelector(`#${tabId}`).classList.add('is-active');
  }

  getSiblings(e) {
      // for collecting siblings
      let siblings = [];
      // if no parent, return no sibling
      if(!e.parentNode) {
          return siblings;
      }
      // first child of the parent node
      let sibling  = e.parentNode.firstChild;
      // collecting siblings
      while (sibling) {
          if (sibling.nodeType === 1 && sibling !== e) {
              siblings.push(sibling);
          }
          sibling = sibling.nextSibling;
      }
      return siblings;
  }

}
customElements.define('module-tabs', ModuleTabs);

window.theme.Collapsible = (function () {
  function Collapsible() {
    const _this = this;
    this.domDelegate = new Delegate(document.body);
    this._attachListeners();
  }

  Collapsible.prototype = {
    ...Collapsible.prototype,
    _attachListeners() {
      this.domDelegate.on(
        'click',
        '[data-action="toggle-collapsible"]:not([disabled])',
        this._toggleCollapsible.bind(this)
      );

      document.addEventListener(
        'collapsible:toggle',
        this._toggleCollapsible.bind(this)
      );
    },

    /**
     * Toggle a given collapsible
     */

    _toggleCollapsible(event, target) {
      const _this = this;

      // If this is an auto-expand and that it reaches the needed breakpoint, we do nothing
      var parentCollapsible = target.closest('.Collapsible__wrapper');

      if (
        parentCollapsible.classList.contains('Collapsible--autoExpand') &&
        window.matchMedia('screen and (min-width: 641px)').matches
      ) {
        return;
      }

      // If the target is null, it may be because someone has sent the global event "collapsible:toggle". If that the case
      // we can retrieve the toggle button by using the event.detail.id
      if (!target && event.detail) {
        target = document.querySelector(
          '[aria-controls="'.concat(event.detail.id, '"]')
        );
      }

      const isOpen = target.getAttribute('aria-expanded') === 'true';
      var parentCollapsible = target.closest('.Collapsible__wrapper');

      if (isOpen) {
        this._close(parentCollapsible);
      } else {
        this._open(parentCollapsible);
      } // We make sure to close any siblings collapsible as well

      if (target.getAttribute('data-close-siblings') !== 'false') {
        window.theme.Dom.getSiblings(parentCollapsible).forEach(
          (collapsibleToClose) => _this._close(collapsibleToClose)
        );
      }
      event.preventDefault();
    },

    /**
     * Open a given collapsible
     */

    _open(collapsible) {
      const toggleButton = collapsible.querySelector('[aria-controls]');

      if (
        !toggleButton ||
        toggleButton.getAttribute('aria-expanded') === 'true'
      ) {
        return; // It's already open
      }

      const collapsibleContent = collapsible.querySelector(
        '#'.concat(toggleButton.getAttribute('aria-controls'))
      );
      toggleButton.setAttribute('aria-expanded', 'true');

      if (collapsibleContent.hasAttribute('aria-hidden')) {
        collapsibleContent.setAttribute('aria-hidden', 'false');
      }

      if (collapsibleContent.style.height === 'auto') {
        return;
      } // To do the animation we temporarily hide it, check the height, and transition to it

      collapsibleContent.style.height = ''.concat(
        collapsibleContent.firstElementChild.scrollHeight,
        'px'
      );
      collapsibleContent.style.visibility = 'visible';
      if (toggleButton.hasAttribute('data-collapsible-force-overflow')) {
        collapsibleContent.style.overflow = 'visible';
      }

      // If there is an autofocus field, we focus it
      const autofocusElement = collapsibleContent.querySelector('[autofocus]');

      if (autofocusElement) {
        autofocusElement.focus();
      }
    },
    /**
     * Close a given collapsible
     */

    _close(collapsible) {
      const toggleButton = collapsible.querySelector('[aria-controls]');

      if (
        !toggleButton ||
        toggleButton.getAttribute('aria-expanded') === 'false'
      ) {
        return; // It's already closed
      }

      const collapsibleContent = collapsible.querySelector(
        '#'.concat(toggleButton.getAttribute('aria-controls'))
      );

      if (toggleButton.hasAttribute('data-collapsible-force-overflow')) {
        collapsibleContent.style.overflow = 'hidden';
      }

      if (collapsibleContent.hasAttribute('aria-hidden')) {
        collapsibleContent.setAttribute('aria-hidden', 'true');
      }

      toggleButton.setAttribute('aria-expanded', 'false');
      collapsibleContent.style.height = ''.concat(
        collapsibleContent.scrollHeight,
        'px'
      ); // Force previous height to allow CSS transition
      collapsibleContent.offsetHeight; // Force redraw
      collapsibleContent.style.height = 0;
      collapsibleContent.style.visibility = 'hidden';
    },
  };

  return Collapsible;
})();

window.theme.CartDrawer = (function () {
  const selectors = {
    drawer: '#CartDrawer',
    form: '#CartDrawerForm',
  };

  function CartDrawer() {
    this.form = document.querySelector(selectors.form);
    this.drawer = new window.theme.Drawers('CartDrawer', 'cart');

    this.init();
  }

  CartDrawer.prototype = {
    ...CartDrawer.prototype,
    init() {
      document.addEventListener('ajaxProduct:added', (evt) => {
        this.open();
      });

      // Dev-friendly way to open cart
      document.addEventListener('cart:open', this.open.bind(this));
      document.addEventListener('cart:close', this.close.bind(this));
    },

    open() {
      this.drawer.open();
    },

    close() {
      this.drawer.close();
    },
  };

  return CartDrawer;
})();

window.theme.MobileNavigation = (function () {
  function MobileNavigation(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.documentElement);
    this.mobileMenuElement = this.element.querySelector('.mobile-menu');
    this.mobileMenuToggleElement = this.element.querySelector('.mobile-menu__open');
    this.isOpen = false;
    this._attachListeners();
  }

  MobileNavigation.prototype = {
    ...MobileNavigation.prototype,
    destroy() {
      this.delegateElement.off();
      this.delegateRoot.off();
      window.removeEventListener('resize', this._calculatMaxHeightListener);
    },

    _attachListeners() {
      this._calculatMaxHeightListener = this._calculateMaxHeight.bind(this);
      this.delegateElement.on(
        'click',
        '[data-action="toggle-menu"]',
        this._toggleMenu.bind(this)
      );
      this.delegateRoot.on('click', this._onWindowClick.bind(this));
      window.addEventListener('resize', this._calculatMaxHeightListener);
    },

    _toggleMenu() {
      this.isOpen = !this.isOpen;
      const $header = document.querySelector('.Header');
      const $btnClose = document.querySelector('.mobile-menu__close');
      this.mobileMenuToggleElement.setAttribute(
        'aria-expanded',
        this.isOpen ? true : false
      );

      this.mobileMenuElement.setAttribute(
        'aria-hidden',
        this.isOpen ? false : true
      );

      if (!this.isOpen) {
        $header.classList.remove('nav-is-open');
        $btnClose.blur();
        this.mobileMenuElement.style.maxHeight = ''; // If closed, we need to close all sub-menus

        document.body.classList.remove('no-mobile-scroll');
        document
          .querySelector('#shopify-section-header')
          .classList.remove('no-transparent-background');
          removeTrapFocus();
      } else {
        $header.classList.add('nav-is-open');
        $btnClose.focus();
        trapFocus(this.mobileMenuElement);

        document.body.classList.add('no-mobile-scroll');
        document
          .querySelector('#shopify-section-header')
          .classList.add('no-transparent-background');
      }

    },

    _calculateMaxHeight() {
      if (this.isOpen) {
        this.mobileMenuElement.style.maxHeight = ''.concat(
          window.innerHeight -
            document.querySelector('.Header').getBoundingClientRect().bottom,
          'px'
        );
      }
    },

    _onWindowClick(event) {
      if (this.isOpen && !this.element.contains(event.target)) {
        this._toggleMenu();
      }
    },
  };

  return MobileNavigation;
})();

window.theme.HeaderSection = (function () {
  function HeaderSection(container) {
    const _this = this;

    this.element = container;
    this.delegateElement = new Delegate(this.element);

    this.options = JSON.parse(
      this.element.getAttribute('data-section-settings')
    );
    this.lastScrollPosition = -1;
    this.isTouch = window.matchMedia(
      '(-moz-touch-enabled: 1), (hover: none)'
    ).matches;

    // Setup Account modal
    this.accountModalButton = this.element.querySelector(
      '[data-action="trigger-account-modal"]'
    );

    if (this.options.isSticky) {
      // Stickyfill.addOne(this.element.parentNode);
    }

    this._attachListeners();

    this._verifyNavigationOverlap(); // We set again some CSS variables that are used for some calculations in CSS

    const mainLogo = this.element.querySelector('.Header__LogoImage--primary');

    if (mainLogo && !mainLogo.complete) {
      mainLogo.addEventListener('load', () => {
        fastdom.measure(() => {
          document.documentElement.style.setProperty(
            '--header-height',
            `${_this.element.clientHeight}px`
          );
          document.documentElement.style.setProperty(
            '--header-is-not-transparent',
            _this.options.hasTransparentHeader ? 0 : 1
          );
        });
      });
    } else {
      fastdom.measure(() => {
        document.documentElement.style.setProperty(
          '--header-height',
          `${_this.element.clientHeight}px`
        );
        document.documentElement.style.setProperty(
          '--header-is-not-transparent',
          _this.options.hasTransparentHeader ? 0 : 1
        );
      });
    }

    const mobileNavigationElement = this.element.querySelector(
      '.header__mobile-nav'
    );

    if (mobileNavigationElement) {
      this.mobileNavigation = new window.theme.MobileNavigation(
        mobileNavigationElement
      );
    }

    window.addEventListener(
      'pageshow',
      this._checkTransparentHeader.bind(this)
    );
  }

  HeaderSection.prototype = {
    ...HeaderSection.prototype,
    onUnload() {
      this.element.removeEventListener(
        'mouseleave',
        this._closeNavigationListener
      );
      this.element.removeEventListener(
        'mouseenter',
        this._focusNavigationListener
      );
      this.element.removeEventListener(
        'focusin',
        this._focusNavigationListener
      );
      this.delegateElement.off();
      window.removeEventListener(
        'scroll',
        this._checkTransparentHeaderListener
      );
      window.removeEventListener(
        'resize',
        this._verifyNavigationOverlapListener
      );

      if (this.options.isSticky) {
        // Stickyfill.removeOne(this.element.parentNode);
      }

      if (this.mobileNavigation) {
        this.mobileNavigation.destroy();
      }
    },

    onSelect() {
      this._checkTransparentHeader();
    },

    // eslint-disable-next-line no-unused-vars
    onBlockSelect(event) {
      const _this2 = this;

      const listItem = event.target.closest('.HorizontalList__Item');

      fastdom.mutate(() => {
        event.target.setAttribute('aria-hidden', 'false');

        if (listItem) {
          listItem.classList.add('is-expanded');
          window.theme.Dom.getSiblings(listItem, '.is-expanded').forEach(
            (item) => {
              item.classList.remove('is-expanded');
            }
          );
        }

        _this2.element.classList.remove('Header--transparent'); // This is needed to make sure everything is visible
      });
    },

    onBlockDeselect(event) {
      const listItem = event.target.closest('.HorizontalList__Item');
      fastdom.mutate(() => {
        event.target.setAttribute('aria-hidden', 'true');

        if (listItem) {
          listItem.classList.remove('is-expanded');
        }
      });

      this._checkTransparentHeader();
    },

    _attachListeners() {
      this._checkTransparentHeaderListener =
        this._checkTransparentHeader.bind(this);
      this._closeNavigationListener = this._closeNavigation.bind(this);
      this._focusNavigationListener = this._focusNavigation.bind(this);
      this._verifyNavigationOverlapListener =
        this._verifyNavigationOverlap.bind(this);
      this.element.addEventListener(
        'mouseleave',
        this._closeNavigationListener
      );
      this.delegateElement.on(
        'mouseenter',
        '.Header__MainNav .HorizontalList__Item, [aria-haspopup]',
        this._openMenu.bind(this),
        true
      );
      this.delegateElement.on(
        'click',
        '.Header__MainNav .HorizontalList__Item .HorizontalList__Item-Button',
        this._toggleNavMenu.bind(this),
        true
      );
      this.delegateElement.on(
        'keydown',
        '.Header__MainNav .HorizontalList__Item .HorizontalList__Item-Button',
        this._openMenuKeyboard.bind(this),
        true
      );
      this.delegateElement.on(
        'keydown',
        '.Header__MainNav .HorizontalList__Item .HorizontalList__Item-Button',
        this._closeMenuKeyboard.bind(this),
        true
      );
      this.delegateElement.on(
        'keydown',
        '.Header__MainNav .HorizontalList__Item .HorizontalList__Item-Button',
        this._closeMenuKeyboardEsc.bind(this),
        true
      );
      this.delegateElement.on(
        'keydown',
        '.DropdownMenu',
        this._closeMenuKeyboardEsc.bind(this),
        true
      );
      this.delegateElement.on(
        'focusin',
        '[aria-haspopup]',
        this._openMenu.bind(this),
        true
      );
      this.delegateElement.on(
        'focusout',
        '[aria-haspopup]',
        this._closeMenu.bind(this),
        false
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-search"]',
        this._closeNavigationListener
      );
      this.delegateElement.on(
        'mouseleave',
        '.DropdownMenu [aria-haspopup]',
        this._closeMenu.bind(this),
        true
      );
      this.delegateElement.on(
        'mouseenter',
        '.DropdownMenu [aria-haspopup]',
        this._adjustDropdownPosition.bind(this),
        true
      );
      this.delegateElement.on(
        'click',
        '[data-action="toggle-menu"]',
        this._focusMobileNavigation.bind(this)
      );

      if (this.isTouch) {
        this.delegateElement.on(
          'click',
          '.Header__MainNav [aria-haspopup]',
          this._handleTouchMenu.bind(this)
        );
      }

      if (this.options.hasTransparentHeader) {
        this.element.addEventListener(
          'mouseenter',
          this._focusNavigationListener
        );
        this.element.addEventListener('focusin', this._focusNavigationListener);
      }

      if (this.options.isSticky && this.options.hasTransparentHeader) {
        window.addEventListener('scroll', this._checkTransparentHeaderListener);
      }

      if (
        this.options.navigationStyle === 'inline' ||
        this.options.navigationStyle === 'logoLeft'
      ) {
        window.addEventListener(
          'resize',
          this._verifyNavigationOverlapListener
        );
      }

      // Setup Account modal
      if (!this.accountModalButton) return;
      const modalId = 'UserModal-account';
      const name = 'user-modal-account';
      new window.theme.Modals(modalId, name);
    },

    _focusNavigation() {
      const _this3 = this;

      fastdom.mutate(() => {
        // if (!_this3.isTouch || window.matchMedia('screen and (min-width: 1008px)').matches) {
        //   _this3.element.classList.remove('Header--transparent');
        // }
        _this3.element.classList.remove('Header--transparent');
      });
    },

    _focusMobileNavigation() {
      const _this7 = this;

      fastdom.mutate(() => {
        if (_this7.element.classList.contains('Header--transparent')) {
          _this7.element.classList.remove('Header--transparent');
        }
      });
    },

    _closeNavigation() {
      const _this4 = this;
      const $headerOuter = document.getElementById('header');
      $headerOuter.classList.remove('dropdown-is-open');
      fastdom.mutate(() => {
        window.theme.Dom.nodeListToArray(
          _this4.element.querySelectorAll('.is-expanded')
        ).forEach((item) => {
          item.classList.remove('is-expanded');
        });
        window.theme.Dom.nodeListToArray(
          _this4.element.querySelectorAll(
            '.Header__MainNav [aria-hidden="false"]'
          )
        ).forEach((item) => {
          item.setAttribute('aria-hidden', 'true');
        });
        window.theme.Dom.nodeListToArray(
          _this4.element.querySelectorAll('.Header__MainNav [aria-expanded="true"]')
        )
        .forEach(function (item) {
          item.setAttribute('aria-expanded', 'false');
        });
      });

      if (this.options.hasTransparentHeader) {
        this._checkTransparentHeader();
      }
    },

    _openMenu(event, target) {
      const inputType = document.documentElement.getAttribute('data-whatinput');

      if (inputType === 'keyboard' && event.type === 'mouseenter') {
        return;
      }

      if (event.type === 'mouseenter' && target !== event.target) {
        return;
      }

      if (target.classList.contains('HorizontalList__Item')) {
        const $headerOuter = document.getElementById('header');
        $headerOuter.classList.add('dropdown-is-open');
      }

      fastdom.mutate(() => {
        target.classList.add('is-expanded');

        window.theme.Dom.nodeListToArray(
          target.children,
          '.Header__MainNav [aria-hidden="true"]'
        ).forEach((item) => {
          item.setAttribute('aria-hidden', 'false');
        });

        target.querySelectorAll('.Header__MainNav [aria-expanded="false"]')
        .forEach(function (item) {
          item.setAttribute('aria-expanded', 'true');
        });

        window.theme.Dom.getSiblings(target, '.is-expanded').forEach((item) => {
          item.classList.remove('is-expanded');
          window.theme.Dom.nodeListToArray(
            item.children,
            '.Header__MainNav [aria-hidden="false"]'
          ).forEach((item) => {
            item.setAttribute('aria-hidden', 'true');
          });
          item.querySelectorAll('.Header__MainNav [aria-expanded="true"]')
          .forEach(function (children) {
            children.setAttribute('aria-expanded', 'false');
          });
        });
      });
    },

    _closeMenu(event, target) {
      if (event.type === 'mouseleave' && target !== event.target) {
        return;
      }

      fastdom.mutate(() => {
        target.classList.remove('is-expanded');
        window.theme.Dom.nodeListToArray(
          target.children,
          '.Header__MainNav [aria-hidden="false"]'
        ).forEach((item) => {
          item.setAttribute('aria-hidden', 'true');
        });
        target.querySelectorAll('.Header__MainNav [aria-expanded="true"]')
        .forEach(function (item) {
          item.setAttribute('aria-expanded', 'false');
        });
      });
    },

    _openMenuKeyboard(event, target) {
      const targetsMatch = target === event.target;
      const isToggleKey = event.key === 'Enter' || event.key === ' ';
      const isTabKey = event.key === 'Tab';

      if (isTabKey) return;

      const targetElement = target.closest('.HorizontalList__Item');

      if (!targetElement) return;

      const isExpanded = targetElement.classList.contains('is-expanded');

      if (isExpanded) return;

      if (event.type === 'keydown' && (!isToggleKey && !isTabKey)) {
        return;
      }

      if (event.type === 'keydown'
        && targetsMatch
        && isToggleKey
      ) {
        event.preventDefault();
      }

      const $headerOuter = document.getElementById('header');
      $headerOuter.classList.add('dropdown-is-open');

      fastdom.mutate(() => {
        targetElement.classList.add('is-expanded');

        window.theme.Dom.nodeListToArray(
          targetElement.children,
          '.Header__MainNav [aria-hidden="true"]'
        ).forEach((item) => {
          item.setAttribute('aria-hidden', 'false');
        });

        targetElement.querySelectorAll('.Header__MainNav [aria-expanded="false"]')
        .forEach(function (item) {
          item.setAttribute('aria-expanded', 'true');
        });
        window.theme.Dom.getSiblings(targetElement, '.is-expanded').forEach((item) => {
          item.classList.remove('is-expanded');
          window.theme.Dom.nodeListToArray(
            item.children,
            '.Header__MainNav [aria-hidden="false"]'
          ).forEach((item) => {
            item.setAttribute('aria-hidden', 'true');
          });
          targetElement.querySelectorAll('.Header__MainNav [aria-expanded="true"]')
          .forEach(function (children) {
            children.setAttribute('aria-expanded', 'false');
          });
        });
      });
    },

    _closeMenuKeyboard(event, target) {
      const targetsMatch = target === event.target;
      const targetElement = target.closest('.HorizontalList__Item');
      const isToggleKey = event.key === 'Enter' || event.key === ' ';
      const isTabKey = event.key === 'Tab';

      if (!targetElement || isTabKey) return;
      const isExpanded = targetElement.classList.contains('is-expanded');

      if (!isExpanded) return;

      if (event.type === 'keydown' && !targetsMatch) {
        return;
      }

      if (event.type === 'keydown'
        && targetsMatch
        && isToggleKey
      ) {
        event.preventDefault();
      }

      if (isExpanded) {
        fastdom.mutate(() => {
          targetElement.classList.remove('is-expanded');
          window.theme.Dom.nodeListToArray(
            targetElement.children,
            '.Header__MainNav [aria-hidden="false"]'
          ).forEach((item) => {
            item.setAttribute('aria-hidden', 'true');
          });
          targetElement.querySelectorAll('.Header__MainNav [aria-expanded="true"]')
          .forEach(function (item) {
            item.setAttribute('aria-expanded', 'false');
          });
        });
      } else {
        fastdom.mutate(() => {
          targetElement.classList.remove('is-expanded');
          window.theme.Dom.nodeListToArray(
            targetElement.children,
            '.Header__MainNav [aria-hidden="false"]'
          ).forEach((item) => {
            item.setAttribute('aria-hidden', 'true');
          });
          targetElement.querySelectorAll('.Header__MainNav [aria-expanded="true"]')
          .forEach(function (item) {
            item.setAttribute('aria-expanded', 'false');
          });
        });
      }
    },

    _closeMenuKeyboardEsc(event, target) {
      const targetElement = target.closest('.HorizontalList__Item');
      const isEscKey = event.key === 'Escape';
      const isTabKey = event.key === 'Tab';

      if (!targetElement || isTabKey) return;

      const isExpanded = targetElement.classList.contains('is-expanded');
      if (!isExpanded) return;
      if (event.type === 'keydown'
        && isEscKey
      ) {
        event.preventDefault();
      }

      if (isExpanded && isEscKey) {
        fastdom.mutate(() => {
          targetElement.classList.remove('is-expanded');
          window.theme.Dom.nodeListToArray(
            targetElement.children,
            '.Header__MainNav [aria-hidden="false"]'
          ).forEach((item) => {
            item.setAttribute('aria-hidden', 'true');
          });
          targetElement.querySelectorAll('.Header__MainNav [aria-expanded="true"]')
          .forEach(function (item) {
            item.setAttribute('aria-expanded', 'false');
          });
          setTimeout(() => {
            document.activeElement.blur();
            const targetElementButton = targetElement.querySelector('.HorizontalList__Item-Button');
            if (targetElementButton) targetElementButton.focus();
          }, 20);
        });
      }
    },

    _toggleNavMenu(event, target) {
      const wrapper = target.closest('.HorizontalList__Item');
      if (!wrapper) return;

      const isExpanded = wrapper.classList.contains('is-expanded');
      const $headerOuter = document.getElementById('header');

      fastdom.mutate(() => {
        if (isExpanded) {
          // CLOSE menu
          wrapper.classList.remove('is-expanded');
          target.setAttribute('aria-expanded', 'false');

          wrapper.querySelectorAll('[aria-hidden="false"]').forEach((el) => {
            el.setAttribute('aria-hidden', 'true');
          });

          wrapper.querySelectorAll('[aria-expanded="true"]').forEach((el) => {
            el.setAttribute('aria-expanded', 'false');
          });

          if ($headerOuter) $headerOuter.classList.remove('dropdown-is-open');
        } else {
          // OPEN menu
          wrapper.classList.add('is-expanded');
          target.setAttribute('aria-expanded', 'true');

          wrapper.querySelectorAll('[aria-hidden="true"]').forEach((el) => {
            el.setAttribute('aria-hidden', 'false');
          });

          wrapper.querySelectorAll('[aria-expanded="false"]').forEach((el) => {
            el.setAttribute('aria-expanded', 'true');
          });

          // Close other menus
          window.theme.Dom.getSiblings(wrapper, '.is-expanded').forEach((sibling) => {
            sibling.classList.remove('is-expanded');

            const siblingButton = sibling.querySelector('.HorizontalList__Item-Button');
            if (siblingButton) siblingButton.setAttribute('aria-expanded', 'false');

            sibling.querySelectorAll('[aria-hidden="false"]').forEach((el) => {
              el.setAttribute('aria-hidden', 'true');
            });

            sibling.querySelectorAll('[aria-expanded="true"]').forEach((el) => {
              el.setAttribute('aria-expanded', 'false');
            });
          });

          if ($headerOuter) $headerOuter.classList.add('dropdown-is-open');
        }
      });
    },

    _adjustDropdownPosition(event, target) {
      const nestedMenus = window.theme.Dom.nodeListToArray(
        target.querySelectorAll('.DropdownMenu')
      );
      let shouldOpenLeft = false;
      fastdom.measure(() => {
        const windowWidth = window.innerWidth;
        const rightEdge = target.getBoundingClientRect().right;
        nestedMenus.forEach((item) => {
          if (rightEdge + item.offsetWidth > windowWidth) {
            shouldOpenLeft = true;
          }
        });
      });
      fastdom.mutate(() => {
        if (shouldOpenLeft) {
          nestedMenus.forEach((item) => {
            item.classList.add('DropdownMenu--reversed');
          });
        } else {
          nestedMenus.forEach((item) => {
            item.classList.remove('DropdownMenu--reversed');
          });
        }
      });
    },

    _handleTouchMenu(event, target) {
      if (!target.classList.contains('is-expanded')) {
        event.preventDefault();
      }
    },

    _verifyNavigationOverlap() {
      const _this5 = this;

      let isOverlapping = false;
      const mainTopMenu = this.element.querySelector('.Header__MainNav');
      fastdom.measure(() => {
        // To detect if the navigation is overlapping, we take the height of a single item and check if its height is taller than the parent
        if (mainTopMenu) {
          // Get the first element
          const firstNavElementHeight = window.theme.Dom.outerHeightWithMargin(
            mainTopMenu.querySelector('.HorizontalList__Item')
          );
          const mainNavHeight = mainTopMenu.scrollHeight;

          if (mainNavHeight > firstNavElementHeight) {
            isOverlapping = true;
          }
        }
      });
      this.element.classList.remove(
        'Header--logoLeft',
        'Header--inline',
        'Header--center'
      );
      this.element.classList.add(
        'Header--'.concat(this.options.navigationStyle)
      );
      this.element.clientWidth; // Forces a reflow

      fastdom.mutate(() => {
        if (isOverlapping) {
          _this5.element.classList.remove(
            'Header--'.concat(_this5.options.navigationStyle)
          );

          _this5.element.classList.add('Header--center'); // Check if still overlapping despite changing the mode

          if (mainTopMenu) {
            // Get the first element
            const itemTopSet = new Set();
            Array.from(
              mainTopMenu.querySelectorAll('.HorizontalList__Item')
            ).forEach((item) => {
              itemTopSet.add(item.getBoundingClientRect().top);
            });
            isOverlapping = itemTopSet.size > 1;
          }
        } else {
          _this5.element.classList.add(
            'Header--'.concat(_this5.options.navigationStyle)
          );

          _this5.element.classList.remove('Header--center');
        }

        const logo = _this5.element.querySelector('.Header__FlexItem--logo');

        logo.classList.toggle('Header__FlexItem--increaseSpace', isOverlapping);

        _this5.element.classList.add('Header--initialized');

        fastdom.measure(() => {
          document.documentElement.style.setProperty(
            '--header-height',
            `${_this5.element.clientHeight}px`
          );
        });
      });
    },

    _checkTransparentHeader() {
      const _this6 = this;

      if (!this.options.hasTransparentHeader) {
        return;
      }

      const scrollThreshold = 10;
      fastdom.measure(() => {
        _this6.lastScrollPosition = window.pageYOffset;
      });
      fastdom.mutate(() => {
        if (_this6.lastScrollPosition <= scrollThreshold) {
          _this6.element.classList.add('Header--transparent');
        } else {
          _this6.element.classList.remove('Header--transparent');
        }
      });
    },
  };

  return HeaderSection;
})();

window.theme.CartDrawerAjax = /* #__PURE__ */ (function () {
  function CartDrawerAjax(container) {
    this.element = container;
    this.delegateElement = new Delegate(this.element);
    this.documentDelegate = new Delegate(document.documentElement);
    this.options = JSON.parse(
      this.element.getAttribute('data-section-settings')
    );
    this.itemCount = this.options.itemCount;

    if (this.options.drawer) {
      if (!document.body.classList.contains('template-cart')) {
        this.sidebarDrawer = new window.theme.CartDrawer();
      }
    }

    this._attachListeners();
  }

  CartDrawerAjax.prototype = {
    ...CartDrawerAjax.prototype,
    onUnload: function onUnload() {
      this.delegateElement.off();
      document.removeEventListener(
        'product:added',
        this._onProductAddedListener
      );
    },

    _attachListeners: function _attachListeners() {
      this._onProductAddedListener = this._onProductAdded.bind(this);

      if (this.options.type !== 'page') {
        this.delegateElement.on(
          'click',
          '[data-action="update-item-quantity"], [data-action="remove-item"]',
          this._updateItemQuantity.bind(this)
        );
        this.delegateElement.on(
          'change',
          '.QuantitySelector__CurrentQuantity',
          this._updateItemQuantity.bind(this)
        );
      } else {
        this.delegateElement.on(
          'change',
          '.QuantitySelector__CurrentQuantity',
          this._reloadPageWithQuantity.bind(this)
        );
      } // We have some listeners that are specific to the fact it's a drawer or the dedicated cart page

      document.addEventListener('product:added', this._onProductAddedListener); // We attach a listener at page level which allows to re-render the cart

      this.documentDelegate.on(
        'cart:refresh',
        this._rerenderCart.bind(this, false)
      );
      window.SDG.currencyFormatter().init();
    },

    _updateItemQuantity: function _updateItemQuantity(event, target) {
      if (window.checkout.enableLimit && window.checkout.variantMax) {
        if (
          target.getAttribute('data-quantity') - 1 >=
            window.checkout.variantMax ||
          target.value > window.checkout.variantMax
        ) {
          event.preventDefault();
          const $limitModal = document.querySelector('.js-limit-modal');

          // reset to previous input value
          if (target.tagName === 'INPUT') {
            target.value = target.getAttribute('value');
          }

          if ($limitModal) $limitModal.classList.toggle('modal--is-active');

          return;
        }
      }

      const _this2 = this;

      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      let quantity = null;
      let elementToAnimate = null;

      if (target.tagName === 'INPUT') {
        quantity = parseInt(Math.max(parseInt(target.value) || 1, 1));
      } else {
        quantity = parseInt(target.getAttribute('data-quantity'));
      } // If the quantity is 0, then we will animate the product with a removal effect

      if (quantity === 0) {
        elementToAnimate = target.closest('.CartItemWrapper');
      }

      fetch(''.concat(window.routes.cart_change_url, '.js'), {
        body: JSON.stringify({
          line: target.getAttribute('data-line'),
          quantity,
        }),
        credentials: 'same-origin',
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest', // This is needed as currently there is a bug in Shopify that assumes this header
        },
      }).then((cart) => {
        cart.json().then((content) => {
          _this2.itemCount = content.item_count;
          window.theme.cartLength = content.item_count;

          if (content.items.length > 0) {
            window.theme.firstCartProdID = content.items[0].product_id;
            window.theme.firstCartVarID = content.items[0].variant_id;
          }

          _this2._rerenderCart(elementToAnimate);

          document.dispatchEvent(new CustomEvent('product:updated'));
          document.dispatchEvent(new CustomEvent('theme:loading:end'));
        });
      });
      event.preventDefault();
    },

    _reloadPageWithQuantity: function _reloadPageWithQuantity(event, target) {
      window.location.href = ''
        .concat(window.routes.cart_change_url, '?quantity=')
        .concat(parseInt(target.value), '&line=')
        .concat(target.getAttribute('data-line'));
    },

    _onProductAdded: function _onProductAdded(event) {
      const _this3 = this;

      this.itemCount += event.detail.quantity;
      window.theme.cartLength += event.detail.quantity;

      fetch(''.concat(window.routes.cartUrl, '.js'))
        .then((response) => response.json())
        .then((data) => {
          if (data.items.length > 0) {
            window.theme.firstCartProdID = data.items[0].product_id;
            window.theme.firstCartVarID = data.items[0].variant_id;
          }
        });

      this._rerenderCart().then(() => {
        _this3.sidebarDrawer.open();
      });
    },

    /**
     * This method is called internally to rerender the cart, based on the content returned by Shopify Ajax API.
     * We could save some performance by updating directly in JavaScript instead of doing a GET call to get the HTML
     * from Shopify, but by experience, this allows for easier app integration as it allows the Liquid to re-run
     * all the time and hence having easier logic.
     */

    _rerenderCart: function _rerenderCart(elementToAnimate) {
      const _this4 = this;

      // Note: appending a timestamp is necessary as the polyfill on IE11 and lower does not support the "cache" property
      return fetch(
        ''
          .concat(window.routes.cartUrl, '?section_id=')
          .concat(
            this.options.drawer && window.theme.pageType !== 'cart'
              ? 'mini-cart'
              : 'main-cart'
          ),
        {
          credentials: 'same-origin',
          method: 'GET',
        }
      ).then((content) => {
        content.text().then((html) => {
          _this4._replaceContent(html);
        });
        document.dispatchEvent(cartEvent);
      });
    },

    _replaceContent: function _replaceContent(html) {
      const _this5 = this;

      const tempElement = document.createElement('div');
      tempElement.innerHTML = html;
      const cartNodeParent = this.element.querySelector('.Cart').parentNode;

      if (this.options.drawer && window.theme.pageType !== 'cart') {
        const currentScrollPosition =
          this.element.querySelector('.Drawer__Main').scrollTop;
        cartNodeParent.replaceChild(
          tempElement.querySelector('.Cart'),
          this.element.querySelector('.Cart')
        );
        this.element.querySelector('.Drawer__Main').scrollTop =
          currentScrollPosition;
      }

      // Klarna Placement Refresh on Cart Update
      window.KlarnaOnsiteService = window.KlarnaOnsiteService || [];
      window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });

      const updateCartSVG = (count) => {
        const emptyCartSVG = document.querySelector('.js-cart-empty-svg');
        const filledCartSVG = document.querySelector('.js-cart-full-svg');

        if (emptyCartSVG && filledCartSVG) {
          if (count > 0) {
            emptyCartSVG.classList.add('hide');
            filledCartSVG.classList.remove('hide');
          } else {
            emptyCartSVG.classList.remove('hide');
            filledCartSVG.classList.add('hide');
          }
        }
      };

      const updateCartCount = (count)  =>{
        const cartCountElement = document.querySelector('.js-header-cart-count');
        if (cartCountElement) {
          if (count > 0) {
            cartCountElement.textContent = count;
          } else {
            cartCountElement.textContent = '';
          }
        }
      }
      // We can also update the dot and the quantity
      const cartResult = JSON.parse(
        tempElement
          .querySelector('[data-section-type="cart-drawer"]')
          .getAttribute('data-section-settings')
      );
      const cartDot = window.theme.Dom.nodeListToArray(
        document.querySelectorAll('.Header__CartDot')
      );
      const cartIcon = window.theme.Dom.nodeListToArray(
        document.querySelectorAll('.header__icon--cart')
      );
      this.itemCount = cartResult.itemCount;

      cartDot.forEach((item) => {
        if (_this5.itemCount === 0) {
          item.classList.remove('is-visible'); // IE 11 and lower does not support second attribute of toggle :(
        } else {
          item.classList.add('is-visible');
        }
      });
      cartIcon.forEach((item) => {
        if (_this5.itemCount === 0) {
          item.setAttribute('aria-label', 'Header Icon: Cart is empty');
        } else if (_this5.itemCount === 1) {
          item.setAttribute('aria-label', 'Header Icon: 1 item in cart');
        } else {
          item.setAttribute('aria-label', `Header Icon: ${_this5.itemCount} items in cart`);
        }
      });

      setTimeout(() => {
        updateCartCount(this.itemCount);
        updateCartSVG(this.itemCount);
      }, 1000);

      window.SDG.currencyFormatter().init();
    },
  };

  return CartDrawerAjax;
})();

window.theme.NewsletterPopupSection = (function () {
  function NewsletterPopupSection(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(element.getAttribute('data-section-settings')); // If the popup has been already displayed, we do not display it

    try {
      if (
        window.location.hash === '#newsletter-popup' &&
        window.window.theme.pageType !== null
      ) {
        this._openPopup();
      } else if (
        !this.options.showOnlyOnce ||
        (this.options.showOnlyOnce &&
          localStorage.getItem('themePopup') === null)
      ) {
        setTimeout(
          this._openPopup.bind(this),
          this.options.apparitionDelay * 1000
        );
      }
    } catch (error) {
      // Some browsers (especially in private mode) throw an exception when trying to access local storage, so we protect ourselves here
    }

    // Open modal if errors or success message exist
    if (element.querySelector('.form-status')) {
      this._openPopup();
    }

    this._attachListeners();
  }

  NewsletterPopupSection.prototype = {
    ...NewsletterPopupSection.prototype,
    onUnload() {
      // Remove all events from elements
      this.delegateElement.off();
    },

    onSelect() {
      this._openPopup();
    },

    onDeselect() {
      this._closePopup();
    },

    _attachListeners(evt) {
      this.delegateElement.on(
        'click',
        '[data-action="close-popup"]',
        this._closePopup.bind(this)
      );
    },

    _openPopup(evt) {
      this.element.setAttribute('aria-hidden', 'false');
      document.body.classList.add('fixed_popup');
      localStorage.setItem('themePopup', 'true');
    },

    _closePopup(evt) {
      this.element.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('fixed_popup');
    },
  };

  return NewsletterPopupSection;
})();

class CareTabs extends HTMLElement {
  constructor() {
    super();

    this.element = this;

    this.selectors = {
      tabList: '[data-tablist]',
      tabLinks: '[data-action="toggle-tabs"]',
      tabContent: '[data-tabcontent]',
    };

    this.querySelectorAll(this.selectors.tabLinks).forEach((currentTab) =>
      currentTab.addEventListener('click', this.onTabClick.bind(this))
    );
  }

  onTabClick(event) {
    event.preventDefault();
    const { target } = event;
    const tabId = target.getAttribute('aria-controls');

    // We remove active attribute from all siblings
    const targetSiblings = this.getSiblings(target);
    for (const targetSibling of targetSiblings) {
      targetSibling.classList.remove('active');
    }

    // We remove current attribute from all content tabs
    const tabContents = this.querySelectorAll(this.selectors.tabContent);
    for (const tabContent of tabContents) {
      tabContent.classList.remove('active');
      tabContent.setAttribute('aria-selected', 'false');
    }

    target.classList.add('active');
    target.setAttribute('aria-selected', 'true');
    this.querySelector(`#${tabId}`).classList.add('active');
  }

  getSiblings(e) {
    // for collecting siblings
    const siblings = [];
    // if no parent, return no sibling
    if (!e.parentNode) {
      return siblings;
    }
    // first child of the parent node
    let sibling = e.parentNode.firstChild;
    // collecting siblings
    while (sibling) {
      if (sibling.nodeType === 1 && sibling !== e) {
        siblings.push(sibling);
      }
      sibling = sibling.nextSibling;
    }
    return siblings;
  }
}
customElements.define('care-tabs', CareTabs);

document.addEventListener('DOMContentLoaded', () => {
  const sections = new window.theme.Sections();

  new window.theme.Collapsible();
  sections.register('header', window.theme.HeaderSection);
  sections.register('cart-drawer', window.theme.CartDrawerAjax);
  sections.register('newsletter-popup', window.theme.NewsletterPopupSection);
});

// FIX TITLE ID's
function removeTitleID() {
  try {
    $.find('.Slide_content--title').forEach((el) => {
      $(el).replaceWith($(el)[0].innerHTML.replace(/- [A-Z0-9]{10}/, ''));
    });
  } catch (e) {}
}
removeTitleID();

(function embroideryFeeCartLogic() {

  /**
   * Init
   */
  function init() {
    if (window.SDG.template === 'cart') {
      getCartAndUpdateEmbroideryCartItems();
    }
    addEvents();
  }

  function addEvents() {
    document.addEventListener('cartrendered', getCartAndUpdateEmbroideryCartItems);
    if (window.SDG.template === 'cart') {
      document.addEventListener('cart:updated', getCartAndUpdateEmbroideryCartItems);
    }
  }

  function getCartAndUpdateEmbroideryCartItems() {
    fetch('/cart.js')
      .then((response) => response.json())
      .then((cart) => {
        updateEmbroideryCartItems(cart);
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  // Checks if quantities are correct and if not - updates it
  function updateEmbroideryCartItems(cart) {
    if (!cart || cart.items.length === 0) return;
    const lineItems = cart.items;

    const embroideryLineItems = lineItems.filter(
      // eslint-disable-next-line no-confusing-arrow, no-unneeded-ternary, no-underscore-dangle
      (item) => (item.properties?._isEmbroidered ? true : false)
    );

    const embroideryFeeLineItems = lineItems.filter(
      // eslint-disable-next-line no-confusing-arrow, no-unneeded-ternary, no-underscore-dangle
      (item) => (item.properties?._isEmbroideryFee ? true : false)
    );

    // Tracking which line items we'll need to update { line_item_key: quantity, ... }
    const updatedItems = {};
    embroideryFeeLineItems.forEach((feeItem) => {
      const embroideryMasterLineItem = embroideryLineItems.find((embroideryItem) => {
        if (embroideryItem.id !== parseInt(feeItem.properties._embroideryVariantId)) return false;
        if (embroideryItem.properties.customization !== feeItem.properties._customization) return false;
        if (embroideryItem.properties.threadColor !== feeItem.properties._threadColor) return false;
        if (embroideryItem.properties.placementPosition !== feeItem.properties._placementPosition) return false;
        if (embroideryItem.properties.fontType !== feeItem.properties._fontType) return false;
        return true;
      });

      let quantity = 0;

      if (!embroideryMasterLineItem) {
        updatedItems[`${feeItem.key}`] = quantity;
      } else if (
        embroideryMasterLineItem &&
        embroideryMasterLineItem.quantity !== feeItem.quantity
      ) {
        quantity = embroideryMasterLineItem.quantity;
        updatedItems[`${feeItem.key}`] = quantity;
      }
    });

    if (Object.keys(updatedItems).length > 0) {
      if(window.SDG.template === 'cart') {
        updateCartPageFeeQuantity(updatedItems);
      } else {
        updateQuantities(updatedItems);
      }
    }
  }

  /**
   * Updated cart items quantities
   * @param {object} updatedItems - { line_item_key: quantity,.... }
   */
  function updateQuantities(updatedItems) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: updatedItems,
      }),
    }).then((response) => {
      if(response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      }
    });
  }

  /**
   * Updates cart items quantities in cart page
   * Works only on cart page
   * @param {object} updatedItems - { line_item_key: quantity,.... }
   */
  function updateCartPageFeeQuantity(updatedItems) {
    for (const [key, value] of Object.entries(updatedItems)) {
      const $cartItemsWrapper = document.querySelector('cart-items');
      const $lineItemWrapper = document.querySelector(`[data-key="${key}"]`);
      if($lineItemWrapper) {
        const lineItemIndex = parseInt($lineItemWrapper.querySelector('cart-remove-button').dataset.index);
        $cartItemsWrapper.updateQuantity(lineItemIndex, value);
      }
    }
  }

  init();
})();
